// extracted by mini-css-extract-plugin
module.exports = {"vzAlert":"vz-alert_vzAlert__2jTzJ","isCompact":"vz-alert_isCompact__3cbJ_","message":"vz-alert_message__zPAHw"};